import React from 'react';
import { Routes, Route, NavLink } from 'react-router-dom';
import TagList from './TagList';
import TagDefinitions from './TagDefinitions';
import TagSearch from './Search';

const Tags = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Tags Management</h1>

      <div className="mb-6">
        <nav className="flex border-b border-gray-200">
          <NavLink
            to="/intel/tags"
            end
            className={({ isActive }) =>
              `px-4 py-2 font-medium text-sm ${
                isActive
                  ? 'border-b-2 border-blue-500 text-blue-600'
                  : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`
            }
          >
            Tags
          </NavLink>
          <NavLink
            to="/intel/tags/definitions"
            className={({ isActive }) =>
              `px-4 py-2 font-medium text-sm ${
                isActive
                  ? 'border-b-2 border-blue-500 text-blue-600'
                  : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`
            }
          >
            Tag Definitions
          </NavLink>
          <NavLink
            to="/intel/tags/search"
            className={({ isActive }) =>
              `px-4 py-2 font-medium text-sm ${
                isActive
                  ? 'border-b-2 border-blue-500 text-blue-600'
                  : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`
            }
          >
            Search
          </NavLink>
        </nav>
      </div>

      <Routes>
        <Route path="/" element={<TagList />} />
        <Route path="/definitions" element={<TagDefinitions />} />
        <Route path="/search" element={<TagSearch />} />
      </Routes>
    </div>
  );
};

export default Tags; 